/**
 * The ONE predicate behind `RequireAdmin` (DNKADM-0434): may this session open the
 * Configuration routes? Admin role AND not in Front Desk view.
 *
 * Lives in its own module so the route guard and the Ask Dink route catalogue
 * (`src/features/ask-dink/routeCatalogue.ts`) answer the question with the same
 * code — the catalogue must never offer a screen the router would refuse.
 * Presentation-only, like the guard itself: dink-api enforces the same on every
 * config endpoint.
 */
export function canOpenAdminRoutes(isAdmin: boolean, frontDeskView: boolean): boolean {
  return isAdmin && !frontDeskView;
}
